import React, { useContext, useState, useEffect } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import { ContractContext } from '../contexts/ContractContext';
import { getPlanByContractId } from '../../helpers';
import { SalesContext } from '../contexts/SalesContext';
import { BrandingContext } from '../contexts/ContractContext';
import moment from 'moment';
import { useCookies } from 'react-cookie';

//bypass logic and allow children to be rendered.
const ResumeContract = ({ children }) => {
    const match = useRouteMatch('/resumequote/:component/:contractId/:clientId');
    const loc = useLocation();

    const history = useHistory();
    const branding = useContext(BrandingContext);
    const context = useContext(SalesContext);
    const planData = context.data.planData;
    const formData = context.data.formData;
    const taxRate = context.data.taxRate;
    const [clientId] = useState(match?.params?.clientId);
    const [contractId, setContractId] = useState(match?.params?.contractId ?? 0);
    const [component] = useState(match?.params?.component);
    const [resumingContract, setResumingContract] = useState(true);
    const [cookies] = useCookies();

    //console.log(match, loc, history, contractId, context, planData, formData);

    useEffect(() => {
        //console.log("TEST", loc.pathname, loc.pathname.toLowerCase().includes('/resumequote'))
        if (!loc.pathname.toLowerCase().includes('/resumequote')) {
            setResumingContract(false);
            return;
        }

        console.log(match);

        resume();
    }, [loc.pathname]);

    const resume = async () => {
        await getPlanByContractId(contractId, clientId ?? ' ', cookies).then((data) => {
            console.log(data);
            if (data != null) {
                setContractId(data.contractId);

                console.log(data);

                context.updatePromoCode(data.promoCode);

                context.updatePlanData(data.planData);
                context.updateFormData(data.formData);

                const total = parseFloat(
                    parseFloat(data.planData.planTotal + parseFloat(data.planData.additionalTotal)).toFixed(2)
                );

                //const taxRate = 6.625 / 100;

                const totalTaxPrice = parseFloat(total * taxRate).toFixed(2);

                const totalWithTax = parseFloat((total * parseFloat(1 + taxRate)).toFixed(2));
                let planDetails = {
                    invitationNumber: data.formData.invitationNumber ?? '0',
                    amount: totalWithTax,
                    clientId: clientId,
                    firstName: data.formData.firstName,
                    lastName: data.formData.lastName,
                    phone: data.formData.phone,
                    email: data.formData.email,
                    doNotSolicit: data.formData.doNotSolicit ? data.formData.doNotSolicit : new Date('01/01/01'),
                    riskProfileModel: data.planData?.selectedPlan?.riskProfile,
                    activeAddPlans: data.planData?.selectedAddPlans.map((i) => i.riskProfile),
                    planData: {
                        selectedPlan: {
                            riskProfile: data.planData?.selectedPlan?.riskProfile
                        },
                        selectedAddPlans: data.planData?.selectedAddPlans,
                        annualPlanTotal: data.planData?.selectedPlan?.yearly
                    },
                    activeAddPlans: data.planData?.selectedAddPlans.map((i) => i.riskProfile),
                    termsAndCondition: false,
                    verifiedAddress: {
                        address1: data.formData?.mailingAddress?.address1,
                        address2: data.formData?.mailingAddress?.address2,
                        city: data.formData?.mailingAddress?.city,
                        state: data.formData?.mailingAddress?.state,
                        stateId: data.formData?.mailingAddress?.stateId,
                        zip: data.formData?.mailingAddress?.zip
                    },
                    billingAddress: {
                        address1: data.formData?.billingAddress?.address1,
                        address2: data.formData?.billingAddress?.address2,
                        city: data.formData?.billingAddress?.city,
                        state: data.formData?.billingAddress?.state,
                        stateId: data.formData?.billingAddress?.stateId,
                        zip: data.formData?.billingAddress?.zip
                    },
                    serviceAddress: {
                        address1: data.formData?.serviceAddress?.address1,
                        address2: data.formData?.serviceAddress?.address2,
                        city: data.formData?.serviceAddress?.city,
                        state: data.formData?.serviceAddress?.state,
                        stateId: data.formData?.serviceAddress?.stateId,
                        zip: data.formData?.serviceAddress?.zip
                    },
                    mailingAddress: {
                        address1: data.formData?.mailingAddress?.address1,
                        address2: data.formData?.mailingAddress?.address2,
                        city: data.formData?.mailingAddress?.city,
                        state: data.formData?.mailingAddress?.state,
                        stateId: data.formData?.mailingAddress?.stateId,
                        zip: data.formData?.mailingAddress?.zip
                    },
                    promoCode: data.promoCode?.name,
                    planDocuments: data.formData.planDocuments,
                    taxAmount: totalTaxPrice,
                    taxRate: taxRate
                };
                if (component.toLowerCase().includes('payment')) {
                    console.log(planDetails, planDetails.planData);
                    history.push({
                        pathname: '/sales/payment',
                        state: {
                            planDetails: planDetails,
                            cookies: cookies
                        }
                    });
                } else {
                    //history.push(`/${component}`);
                    history.push({
                        pathname: `/${component}`,
                        state: { planDetails: planDetails }
                    });
                }
            }
        });
    };

    if (resumingContract) return null;

    return children;
};
export default ResumeContract;
